import { useEffect, useState } from 'react';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildProjectTypesRequest } from './utils';

const useGetProjectTypes = (accountId) => {
  const [projectTypes, setProjectTypes] = useState([]);
  const {
    data: projectTypesData,
    doFetch: doFetchProjectTypes,
    loading: isFetchingProjectTypes,
  } = useDataApi();

  useEffect(() => {
    if (accountId == null) return;

    doFetchProjectTypes(buildProjectTypesRequest(accountId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);

  useEffect(() => {
    if (projectTypesData == null) return;

    setProjectTypes(projectTypesData.results);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectTypesData]);

  return { projectTypes, isFetchingProjectTypes };
};

export default useGetProjectTypes;
